module.exports = __webpack_public_path__ + "media/assets/images/flags/co-53ec495e8fdb91c18c8ae8e346fd92af.svg";